import { render } from "./icon-plus-circle.vue?vue&type=template&id=29fcc34e"
import script from "./icon-plus-circle.vue?vue&type=script&lang=js"
export * from "./icon-plus-circle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__